import { useState, useEffect, useCallback } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { TextField, Box } from "@mui/material";
import axios from "axios";
import JobDetailsDialog from "../JobsDialog/JobsDialog";

const PAGE_SIZE = 10;

export default function RecoJobs() {
	const [rows, setRows] = useState([]);
	const [rowCount, setRowCount] = useState(0);
	const [page, setPage] = useState(0);
	const [searchQuery, setSearchQuery] = useState("");
	const [loading, setLoading] = useState(false);
	const [debouncedSearch, setDebouncedSearch] = useState("");

	const [dialogOpen, setDialogOpen] = useState(false);
	const [selectedRow, setSelectedRow] = useState(null);
	const [jobId, setJobId] = useState(null);

	const handleRowClick = (params) => {
		setJobId(params.row.id);
		setDialogOpen(true);
	};

	// Debounce search
	useEffect(() => {
		const handler = setTimeout(() => setDebouncedSearch(searchQuery), 600);
		return () => clearTimeout(handler);
	}, [searchQuery]);

	const fetchData = useCallback(async () => {
		try {
			setLoading(true);

			const res = await axios.get(`/api/shipping_partner_reco/get_supplier_reco_jobs`, {
				params: {
					page: page + 1,
					limit: PAGE_SIZE,
					search: debouncedSearch,
				},
			});

			const data = res.data; // axios returns data directly

			setRows(data.results);
			setRowCount(data.total);
		} catch (error) {
			console.error("Error fetching data:", error);
		} finally {
			setLoading(false);
		}
	}, [page, debouncedSearch]);

	useEffect(() => {
		fetchData();
	}, [fetchData]);

	const columns = [
		{ field: "id", headerName: "ID", width: 100 },
		{ field: "shipping_partner", headerName: "Shipping Partner Name", width: 200 },
		{ field: "month", headerName: "Month", width: 150 },
		{ field: "year", headerName: "Year", width: 150 },
		{ field: "created_by", headerName: "Created By", width: 150 },
		{
			field: "status",
			headerName: "Status",
			width: 150,
			renderCell: (params) => (params.row.status ? "Completed" : "In Progress"),
		},
	];

	return (
		<Box sx={{ height: 520, width: "100%" }}>
			{/* <TextField
				label="Search..."
				variant="outlined"
				size="small"
				fullWidth
				sx={{ mb: 2 }}
				value={searchQuery}
				onChange={(e) => setSearchQuery(e.target.value)}
			/> */}

			<DataGrid
				rows={rows}
				columns={columns}
				loading={loading}
				pagination
				paginationMode="server"
				rowCount={rowCount}
				paginationModel={{ page, pageSize: PAGE_SIZE }}
				onPaginationModelChange={(model) => {
					setPage(model.page);
					// PAGE_SIZE is fixed, but if you want to allow changes:
					// setPageSize(model.pageSize);
				}}
				pageSizeOptions={[PAGE_SIZE]}
				disableRowSelectionOnClick
				onRowClick={handleRowClick}
			/>

			<JobDetailsDialog open={dialogOpen} onClose={() => setDialogOpen(false)} jobId={jobId} />
		</Box>
	);
}
